import React, { SVGProps } from 'react';

const SvgPriceReductionIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 18 18" {...props}>
    <g clipPath="url(#clip0_312_40410)">
      <path
        d="M11.996 12.7456H16.4945V8.24707"
        stroke={props.color || '#1E42A6'}
        strokeWidth="1.4995"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.4946 12.7456L10.1217 6.37267L6.3729 10.1214L1.49951 5.24805"
        stroke={props.color || '#1E42A6'}
        strokeWidth="1.4995"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_312_40410">
        <rect width="17.994" height="17.994" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
SvgPriceReductionIcon.defaultProps = {
  width: '18',
  height: '18',
  color: '#1E42A6',
};
export default SvgPriceReductionIcon;

